"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWARD_RENAMES = exports.awardNames = void 0;
exports.maybeRenamedAward = maybeRenamedAward;
exports.awardNames = [
    'Landlord',
    'Scientist',
    'Banker',
    'Thermalist',
    'Miner',
    'Celebrity',
    'Industrialist',
    'Desert Settler',
    'Estate Dealer',
    'Benefactor',
    'Contractor',
    'Cultivator',
    'Excentric',
    'Magnate',
    'Space Baron',
    'Venuphile',
    'Entrepreneur',
    'Full Moon',
    'Lunar Magnate',
    'Curator',
    'A. Engineer',
    'Tourist',
    'A. Zoologist',
    'Cosmic Settler',
    'Botanist',
    'Promoter',
    'A. Manufacturer',
    'Zoologist',
    'Biologist',
    'T. Politician',
    'Urbanist',
    'Warmonger',
    'Forecaster',
    'Edgedancer',
    'Visionary',
    'Naturalist',
    'Voyager',
    'Traveller',
    'Landscaper',
    'Highlander',
    'Manufacturer',
    'Blacksmith',
    'Kingpin',
    'Excavator',
    'Rugged',
    'Administrator',
    'Collector',
    'Constructor',
    'Electrician',
    'Founder',
    'Incorporator',
    'Investor',
    'Metropolist',
    'Mogul',
    'Politician',
    'Suburbian',
];
exports.AWARD_RENAMES = new Map([
    ['EdgeLord', 'Excavator'],
]);
function maybeRenamedAward(name) {
    const renamed = exports.AWARD_RENAMES.get(name);
    return renamed ?? name;
}
